import React from 'react';
import { connect } from 'react-redux';
import Highcharts from 'highcharts';
import dataUtils from '../../../util/dataUtils';
import highchartFactory from '../../../util/highcharts';
const highchartUtils = highchartFactory();

const chartConfig = {
  exporting: {
    enabled: false,
  },
  credits: {
    enabled: false,
  },
  chart: {
    backgroundColor: '#fff',
    type: 'scatter',
  },
  title: {
    text: '',
  },
  xAxis: {
    labels: {
      style: {
        fontSize: '12px',
      },
    },
    gridLineColor: '#F5F5F5',
    gridLineWidth: 1,
    categories: [],
  },
  yAxis: {
    allowDecimals: false,
    gridLineColor: '#F5F5F5',
    gridLineWidth: 1,
    title: {
      enabled: false,
    },
    labels: {
      style: {
        fontSize: '12px',
      },
    },
  },
  legend: {
    enabled: false,
  },
  plotOptions: {
    series: {
      stickyTracking: false,
    },
    scatter: {
      marker: {
        symbol: 'circle',
        radius: 3,
        states: {
          hover: {
            lineColor: 'rgb(100,100,100)',
          },
        },
      },
      states: {
        hover: {
          marker: {
            enabled: false,
          },
        },
      },
    },
  },
  series: [],
};

class CTAChart extends React.Component {
  componentDidMount() {
    this.chart = new Highcharts['Chart'](`${this.props.id}-details`, chartConfig);

    if (this.props.data.series) {
      this.updateChart();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.data.series && prevProps.data != this.props.data) {
      this.updateChart(prevProps.data);
    }
  }

  componentWillUnmount() {
    this.chart.destroy();
  }

  updateChart(oldData = {}) {
    _.forEach(this.props.data.series, (s) => {
      delete s.marker;
    });

    this.chart.update(
      {
        xAxis: {
          categories: this.props.data.categories,
        },
      },
      false
    );

    const diff = dataUtils.getDiff(oldData.series, this.props.data.series, 'data');
    highchartUtils.updateSeries(diff, this.chart);

    this.chart.redraw();
  }

  render() {
    return (
      <div id={this.props.id} className={this.props.className}>
        <div>
          <div id={`${this.props.id}-details`}></div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    colorsEnabled: state.filters.cta.colorsEnabled,
  };
};

export default connect(mapStateToProps)(CTAChart);
